/*
 * @Author: hippo
 * @Date: 2023-06-14 09:22:25
 * @LastEditors: hippo
 * @LastEditTime: 2023-06-15 09:35:23
 * @FilePath: /subang-console/src/components/dialogs/OrderPreviewDrawer/index.js
 * @Description: 
 * 
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved. 
 */
import React, { Component, useState, useRef, Fragment } from 'react'
import { useMount } from 'react-use'
import { connect } from 'react-redux'
import { sagaModal } from 'redux-saga-modal'
import { Form, Drawer, Button, message, Select, Input, InputNumber } from 'antd'
import styles from './changeBalanceDialog.module.scss'
import OrderDetail from '@/containers/workspace/components/OrderDetail'
import MessageList from '@/containers/workspace/components/MessageBox/List'

const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 15 },
}

function OrderPreview({ id, hide }) {
  console.log('OrderPreview', id)
  return (
    <div className={styles.container}>
      <div className={styles.detail} >
        <OrderDetail
          orderId={id}
          readOnly={true}
          isDrawer={true}
          hide={hide}
        />
      </div>
      {/* <MessageList
        orderId={id}
        readOnly={true}
        isDrawer={true}
        className={styles.message} /> */}
    </div>
  )
}

const ChangeBalance = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Drawer
    title={ownProps.title}
    destroyOnClose
    width={560}
    placement="right"
    visible={isOpen}
    onClose={hide}
    bodyStyle={{ padding: '0 10px' }}>
    <OrderPreview hide={hide} {...ownProps} />
  </Drawer>
)

export default sagaModal({
  name: 'ORDER_PREVIEW',
})(ChangeBalance)
